import styled from '@emotion/styled'
import { colors } from 'component-library/__styling/settings'
import { calcRem, breakpoint } from 'component-library/__styling/style-functions'
import { themedValue } from 'component-library/__styling/themed-value'

export const StyledHeading = styled('h1')(({ theme }) => ({
    width: '100%',
    fontSize: calcRem(22),
    lineHeight: 1.15,
    margin: `0 0 ${calcRem(theme.margins.md)} 0`,
    padding: 0,

    [breakpoint('sm')]: {
        fontSize: calcRem(32),
    },
}))
StyledHeading.displayName = 'SearchHeading'

export const StyledMessage = styled('p')(({ theme }) => ({
    width: '100%',
    fontSize: calcRem(22),
    fontWeight: 700,
    lineHeight: 1.2,
    margin: calcRem(theme.margins.md, 0),

    [breakpoint('sm')]: {
        fontSize: calcRem(32),
    },
}))
StyledMessage.displayName = 'SearchMessage'

export const StyledSearchTerm = styled('span')(({ theme }) => ({
    fontWeight: 400,
    fontStyle: 'italic',
    color: themedValue(theme, {
        thewest: colors.thewest.greyElephant,
        sevennews: colors.sevennews.stormGrey,
        perthnow: colors.perthnow.greyMarble,
    }),
}))
StyledSearchTerm.displayName = 'SearchTerm'
